import {
  onIdTokenChanged,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
} from "firebase/auth";
import { auth } from "../../lib/firebase/auth";
import { http } from "../api/http";
import { SUPPORT_ACCESS_DENIED_MESSAGE, assertSupportPanelAccess } from "./supportAccess";

class AuthService {
  constructor() {
    this.unsubscribeToken = null;
    this.setupTokenListener();
  }

  setupTokenListener() {
    if (this.unsubscribeToken) {
      this.unsubscribeToken();
    }

    this.unsubscribeToken = onIdTokenChanged(auth, async (user) => {
      if (!user) {
        localStorage.removeItem("token");
        localStorage.removeItem("firebaseUid");
        return;
      }

      localStorage.setItem("firebaseUid", user.uid);
      const idToken = await user.getIdToken();
      localStorage.setItem("token", `Bearer ${idToken}`);
    });
  }

  async signIn(email, password) {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const uid = userCredential.user.uid;
    localStorage.setItem("firebaseUid", uid);
    const idToken = await userCredential.user.getIdToken();
    localStorage.setItem("token", `Bearer ${idToken}`);

    try {
      await assertSupportPanelAccess();
    } catch (error) {
      await this.signOut();
      throw error instanceof Error ? error : new Error(SUPPORT_ACCESS_DENIED_MESSAGE);
    }

    return userCredential.user;
  }

  async fetchUserProfile() {
    const response = await http.get("/user/me/profile");
    const account = response.data;

    localStorage.setItem("selectedAccount", JSON.stringify(account));

    const existingCompany = localStorage.getItem("selectedCompany");
    if (
      !existingCompany &&
      account &&
      Array.isArray(account.companies) &&
      account.companies.length > 0
    ) {
      localStorage.setItem("selectedCompany", JSON.stringify(account.companies[0]));
    }

    return account;
  }

  async signOut() {
    await firebaseSignOut(auth);
    localStorage.removeItem("token");
    localStorage.removeItem("firebaseUid");
    localStorage.removeItem("selectedAccount");
    localStorage.removeItem("selectedCompany");
  }
}

export const authService = new AuthService();
